import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Combobox } from "@/components/ui/combobox";
import { ComboboxMulti } from "@/components/ui/combobox_mutli";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CommodityOptions } from "@/lib/api/commodity";
import type { ApiFilterValues } from "./types";
import { DEFAULT_FILTER_VALUES } from "./types";

interface TicketFilterModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  draftFilters: ApiFilterValues;
  setDraftFilters: React.Dispatch<React.SetStateAction<ApiFilterValues>>;
  onApply: () => void;
  locationOptions: { value: string; label: string }[];
  customerOptions: { value: string; label: string }[];
  shipCustomerOptions: { value: string; label: string }[];
}

export function TicketFilterModal({
  open,
  onOpenChange,
  draftFilters,
  setDraftFilters,
  onApply,
  locationOptions,
  customerOptions,
  shipCustomerOptions,
}: TicketFilterModalProps) {
  const handleClear = () => {
    setDraftFilters({ ...DEFAULT_FILTER_VALUES });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] md:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>API Filters</DialogTitle>
        </DialogHeader>

        <form onSubmit={(e) => { e.preventDefault(); onApply(); }}>
          <div className="space-y-4 py-2">
            <div className="flex flex-col gap-1">
              <Label htmlFor="filter-scale-ticket-id" className="text-xs">Scale Ticket ID</Label>
              <Input
                id="filter-scale-ticket-id"
                placeholder="Scale Ticket ID"
                value={draftFilters.scaleTicketId}
                onChange={(e) =>
                  setDraftFilters((prev) => ({ ...prev, scaleTicketId: e.target.value }))
                }
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label htmlFor="filter-ship-date" className="text-xs">Ship Date</Label>
              <Input
                id="filter-ship-date"
                type="date"
                value={draftFilters.shipDate}
                onChange={(e) =>
                  setDraftFilters((prev) => ({ ...prev, shipDate: e.target.value }))
                }
              />
            </div>

            <div className="flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-4">
            <div className="flex flex-col gap-1">
              <Label className="text-xs">Location</Label>
              <Combobox
                options={locationOptions}
                value={draftFilters.plcId}
                onValueChange={(val) =>
                  setDraftFilters((prev) => ({ ...prev, plcId: val }))
                }
                placeholder="Select location..."
                isModal
                dwimOnChange
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-xs">Commodity</Label>
              <Combobox
                options={CommodityOptions}
                value={draftFilters.commodityId}
                onValueChange={(val) =>
                  setDraftFilters((prev) => ({ ...prev, commodityId: val }))
                }
                placeholder="Select commodity..."
                isModal
                dwimOnChange
              />
            </div>
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-xs">Customers</Label>
              <ComboboxMulti
                options={customerOptions}
                value={draftFilters.customerIds}
                onValueChange={(val) =>
                  setDraftFilters((prev) => ({ ...prev, customerIds: val }))
                }
                placeholder="Select customers..."
                isModal
                dwimOnChange
                virtualizeList
                className="w-full"
                popoverClassName="w-[400px] md:w-[500px]"
              />
            </div>


            <div className="flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-4">
            <div className="flex flex-col gap-1">
              <Label className="text-xs">Origin</Label>
              <Combobox
                options={shipCustomerOptions}
                value={draftFilters.shipFrom}
                onValueChange={(val) =>
                  setDraftFilters((prev) => ({ ...prev, shipFrom: val }))
                }
                placeholder="Select From"
                isModal
                dwimOnChange
                virtualizeList
                className="w-full"
                popoverClassName="w-[400px] md:w-[500px]"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-xs">Destination</Label>
              <Combobox
                options={shipCustomerOptions}
                value={draftFilters.shipTo}
                onValueChange={(val) =>
                  setDraftFilters((prev) => ({ ...prev, shipTo: val }))
                }
                placeholder="Select Destination"
                isModal
                dwimOnChange
                virtualizeList
                className="w-full"
                popoverClassName="w-[400px] md:w-[500px]"
              />
            </div>
            </div>
          </div>

          <div className="flex justify-between pt-2">
            <Button type="button" variant="outline" onClick={handleClear}>
              Clear All
            </Button>
            <div className="flex gap-2">
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button type="submit">
                Apply Filters
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
